import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';

import useExcelData from 'hooks/useExcelData';
import ExcelView from 'components/spreadsheet/ExcelView';

const EditVendorItemsModal = ({ show, onHide, selectedItems, onSave }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { data, setData, handleCellsChanged } = useExcelData([]);

  useEffect(() => {
    if (selectedItems && selectedItems.length > 0) {
      const formatedData = selectedItems.map(item => ({
        id: item.id,
        name: item.product?.name || '',
        brand: item.product?.brand?.name || '',
        barcode: item.product?.barcode || '',
        weight: item.product?.weight?.value || '',
        vendor_sku: item.vendor_sku || '',
        unit_price: item.unit_price || '',
        comments: item.comments || '',
      }));

      setData(formatedData);
    }
  }, [selectedItems, setData]);

  const columns = [
    { key: 'name', header: 'Name', disabled: true, width: 300 },
    { key: 'brand', header: 'Brand', disabled: true },
    { key: 'barcode', header: 'Barcode', disabled: true },
    { key: 'weight', header: 'Weight (g)', disabled: true },
    { key: 'vendor_sku', header: 'Vendor SKU' },
    { key: 'unit_price', header: 'Unit Price', type: 'number' },
    { key: 'comments', header: 'Comments' },
  ];

  const handleSave = async () => {
    setIsSaving(true);

    try {
      const updatedItems = data.map(row => ({
        id: row.id,
        vendor_sku: row.vendor_sku,
        unit_price: row.unit_price,
        comments: row.comments,
      }));

      await onSave(updatedItems);
      onHide();
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} fullscreen={true}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Vendor Items</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {data.length === 0 ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <ExcelView
            data={data}
            columns={columns}
            onCellsChanged={handleCellsChanged}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={isSaving || data.length === 0}
        >
          {isSaving ? 'Saving...' : 'Save Changes'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditVendorItemsModal;
